module.exports = __webpack_public_path__ + "ad470efba51723fcbdb2f5bd40a2627e.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/modules/home/components/images/football.png
 ** module id = 1568
 ** module chunks = 0
 **/